<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="4">
              <b-form-group class="mb-0">
                <b-form-input type="text" id="search" placeholder="Search for device..." v-model="searchString" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="pt-0" v-show="locations.length > 1">
              <b-form-group class="mb-0">
                <b-select :options="locationOptions" v-model="locationFilter"></b-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                Devices
              </b-col>
              <b-col cols="6" class="text-right">
                <b-btn size="sm" v-if="$can('create', 'devices')" variant="success" @click="add" class="mr-1"><i class="icon-plus mr-1"></i>Add</b-btn>
                <b-btn size="sm" v-if="$can('create', 'devices')" variant="success" @click="assign" :disabled="!canAssignDevices"><i class="icon-shuffle mr-1"></i>Assign</b-btn>
              </b-col>
            </b-row>
          </template>
          <b-table :hover="true" class="mb-2 table-outline" responsive="sm" head-variant="light" :items="filteredDevices" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
            <template v-slot:cell(MACAddress)="data">
              {{ data.item.MACAddress ? data.item.MACAddress : '--' }}
            </template>
            <template v-slot:cell(status)="data">
              <device-status :deviceId="data.item.id" v-bind:key="data.item.id"></device-status>
            </template>
            <template v-slot:cell(lastConfig)="data">
              <div class="small text-muted" v-show="data.item.lastConfig">Last Config Checkin</div>
              <strong>
                <date :value="data.item.lastConfig" :fromNow="true"></date>
              </strong>
              <span v-if="!data.item.lastConfig">--</span>
            </template>
            <template v-slot:cell(actions)="data">
              <b-link v-if="$can('sync', 'devices')" :disabled="checkingConfig" @click="checkConfig(data.item)" v-b-tooltip.hover title="Config Checkin"><i class="fa fa-cloud"></i></b-link>
              <b-link v-if="$can('reboot', 'devices')" :disabled="rebooting" @click="reboot(data.item)" class="ml-2 mr-2" v-b-tooltip.hover title="Reboot Device"><i class="fa fa-power-off"></i></b-link>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="getRowCount(filteredDevices)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <add-device-modal @add="addDevice" />
    <assign-device-modal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Date from '@/components/text/Date'
import DeviceStatus from '@/components/badges/DeviceStatus'
import Loading from '@/components/text/Loading'
import AddDeviceModal from './partials/AddDevice.vue'
import AssignDeviceModal from './partials/AssignDevice.vue'

// Search filter
const _textSearch = (searchString) => {
  return o => searchString.length === 0 || o.name.toLowerCase().includes(searchString.toLowerCase()) || (o.MACAddress && o.MACAddress.toLowerCase().includes(searchString.toLowerCase()))
}

const _locationSearch = (locationId) => {
  return o => locationId === null || o.locationId === locationId
}

export default {
  name: 'devices',
  components: {
    AddDeviceModal,
    AssignDeviceModal,
    Date,
    DeviceStatus,
    Loading
  },
  computed: {
    ...mapGetters({
      account: 'global/account',
      devices: 'account/devices',
      locations: 'account/locations',
    }),
    filteredDevices () {
      return this.devices
        .filter(_textSearch(this.searchString))
        .filter(_locationSearch(this.locationFilter))

    },
    locationOptions () {
      return [
        { value: null, text: 'All Locations' }
      ].concat(this.locations.map((o) => {
        return { value: o.id, text: o.name }
      }))
    },
    canAssignDevices () {
      return (this.devices.filter(o => !o.type.isSoftPhone && o.MACAddress === null).length > 0)
    }
  },
  data () {
    return {
      caption: 'Devices',
      checkingConfig: false,
      rebooting: false,
      hover: false,
      striped: true,
      bordered: false,
      small: false,
      fixed: false,
      fields: [
        { key: 'status', label: '', class: 'status-col' },
        { key: 'name' },
        { key: 'MACAddress', label: 'MAC Address' },
        { key: 'type.name', label: 'Type' },
        { key: 'lastConfig', label: 'Activity' },
        { key: 'actions', label: '', class: 'text-right actions' }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      searchString: '',
      locationFilter: null
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:addDevice')
    },
    assign () {
      this.$bus.$emit('modal:assignDevice')
    },
    addDevice (device) {
      this.$router.push(`/phones/devices/${device.id}`)
    },
    rowClicked (row) {
      this.$router.push(`/phones/devices/${row.id}`)
    },
    checkConfig (device) {
      this.checkingConfig = true
      this.$axios.post(`/v1/devices/${device.id}/notify/config`).then(() => {
        this.checkingConfig = false
      }).catch((err) => {
        console.error(err)
      })
    },
    reboot (device) {
      this.rebooting = true
      this.$axios.post(`/v1/devices/${device.id}/notify/reboot`).then(() => {
        this.rebooting = false
      }).catch((err) => {
        console.error(err)
      })
    },
    getRowCount (items) {
      return items.length
    },
  },
}
</script>

<style lang="scss">
td {
  &.status-col {
    width: 3rem;
  }

  &.actions {
    font-size: 1.125rem;
    width: 6rem;
  }
}
</style>
